import * as React from "react";
import "./loading.css";

export const ContentLoading: React.FC<{ topOffset?: number }> = ({ topOffset = 100 }) => (
    <div
        style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: topOffset, 
        }}
    >
        <div>
            <div className="spinner-boot"></div>
        </div>
    </div>
);


export default ContentLoading;



// WEBPACK FOOTER //
// ./ClientApp/components/common/ContentLoading.tsx